module.exports = __webpack_public_path__ + "img/right-8.b7f7eba0.png";